export default "__VITE_ASSET__BfIqu0yy__"